import Clouds from 'components/Clouds'
import FrontElement from 'components/FrontElement'
import StandardParagraph from 'components/StandardParagraph'
import ImageCaption from 'components/ImageCaption/ImageCaption'
// Profile Images
import GigiOeriImage from './Images/GigiOeri.png'
import Hayek from './Images/Hayek.png'
import RainerMarcFrey from './Images/RainerMarcFrey.png'
import Rolex from './Images/RolexCrown.png'
import NameImage from 'components/NameImage'
// Jet Images
import HBJIP from './Images/HBJIP.jpg'
import HBVRF1 from './Images/HBVRF1.jpg'
import HBVYM from './Images/HBVYM.png'
import HBJFX from './Images/HBJFX.jpg'

export const localeDE: Locale = {
  clouds: {
    title: (
      <>
        Der CO<sub>2</sub>-Ausstoss einer Durchschnitts&shy;schweizer:in im Vergleich
        zu Gigi Oeris Jet
      </>
    ),
    lead: (
      <>
        In Tonnen CO<sub>2</sub> pro Jahr
      </>
    ),
    swissPerson: 'Durchschnittsschweizer:in',
    privateJet: 'Gigi Oeris Jet',
    hintTitle: 'Quelle:',
    hintText: 'Flugbewegungen Opensky und eigene Berechnungen',
  },
  infoBoard: {
    distance: 'zurückgelegte Distanz',
    date: 'Datum',
  },
  scrollyTellingFrontContent: [
    <FrontElement>
      <NameImage>
        <img src={GigiOeriImage} alt='Gigi Oeri' />
        <h3>Gigi Oeri</h3>
      </NameImage>
      <StandardParagraph>
        Die Basler Roche-Erbin Gigi Oeri fliegt in einem Falcon 2000LX des
        französischen Herstellers Dassault. Je nach Ausstattung bietet dieser
        Jet Platz für 8 bis 13 Passagiere. Pro Flugstunde verbrennt er fast 1000
        Liter Kerosin, was einem CO<sub>2</sub>-Ausstoss von 2,5 Tonnen
        entspricht.
      </StandardParagraph>
      <StandardParagraph>
        2022 hob der von Gigi Oeri genutzte Jet genau 129 Mal ab - und zwar
        meistens für dieselbe Strecke: Basel - Ibiza oder retour. Rund hundert
        Mal flog die Falcon letztes Jahr diese Strecke. Insgesamt stiess der Jet
        2022 circa 600 Tonnen CO<sub>2</sub> in die Luft - über 40 Mal mehr, als
        eine Schweizerin oder ein Schweizer pro Jahr für alle Lebensbereiche
        verbraucht.
      </StandardParagraph>
      <img src={HBJIP} alt='HB-JIP Jet' />
      <ImageCaption>Der von Gigi Oehri genutzte Falcon-Jet</ImageCaption>
      <StandardParagraph>
        Gigi Oeri hat sowohl in Basel als auch auf Ibiza einen Wohnsitz. Ein
        Sprecher von ihr bestätigt, dass «Frau Oeri für Reisen von und zu ihrem
        Zweitdomizil in Ibiza aufgrund der Insellage ein Privatflugzeug
        einsetzt.» Wie oft Oeri persönlich an Bord ist und wie viele Passagiere
        jeweils mitfliegen, ist nicht bekannt. Die Flüge würden «wenn möglich
        kombiniert mit Einsätzen für gemeinnützige Stiftungen von Frau Oeri», so
        der Sprecher weiter. Die Umweltbelastung für alle Flüge werde
        «vollumfassend kompensiert».
      </StandardParagraph>
      <StandardParagraph>
        Was genau für die Stiftungen erledigt wird, führt der Sprecher auch auf
        Nachfragen nicht aus. Hinweise gibt es aus spanischen Medienbeiträgen
        von 2017 . Demnach fliegt eine Stiftung von Gigi Oeri Strassenhunde aus
        Ibiza mit dem Privatjet zur Adoption in die Schweiz. Bis 2017 sollen so
        schon mehrere Hundert Hunde transportiert worden sein. Die Stiftung
        betreibt sowohl auf Ibiza als auch in der Schweiz ein Hundeheim.
        <Clouds />
      </StandardParagraph>
    </FrontElement>,
    <FrontElement>
      <NameImage>
        <img src={Hayek} alt='Hayek' />
        <h3>Familie Hayek</h3>
      </NameImage>
      <StandardParagraph>
        Zuletzt hob die Embraer Phenom 300 Ende April von Grenchen in Richtung
        Barcelona ab. Der vergleichsweise kleine Jet für bis zu 8 Personen ist
        besonders bei Geschäftsreisenden beliebt, da er mit 8 bis 10 Millionen
        Dollar relativ günstig ist. Der Jet gehört der Familie Hayek, die extra
        für den Betrieb des Fliegers die Firma Manhag AG gegründet hat. Deren
        Sitz ist im aargauischen Meisterschwanden, dem Familiensitz der Hayeks.
        Die Geschwister Naila und Nick sind im Verwaltungsrat, ebenso Nailas
        Sohn, Marc Hayek.
      </StandardParagraph>
      <img src={HBVYM} alt='HB-VYM Jet' />
      <ImageCaption>Der Embraer-Jet der Hayeks</ImageCaption>
      <StandardParagraph>
        Der Flieger wird rege genutzt. Die Flugdaten von 2022 zeigen, dass die
        Maschine in dem Jahr 149-mal abhob und 158 Stunden in der Luft
        verbrachte. Besonders oft steuerte der Jet den Flugplatz Grenchen an,
        h&auml;ufig von nahen Destinationen wie Genf oder Z&uuml;rich aus. Von
        Grenchen sind es nur noch 15 Autominuten bis zum Hauptsitz der
        Swatch-Gruppe in Biel. Hayek &ndash; der selber eine Fluglizenz besitzt
        &ndash; fliegt gern mit seinem Helikopter zur Arbeit in der
        Firmenzentrale, wo er die Maschine einfach auf der Wiese vor dem
        Geb&auml;ude parkiert. Das gebe ihm ein Gef&uuml;hl von
        Unabh&auml;ngigkeit, sagte er gegen&uuml;ber der &laquo;Welt&raquo;
        einmal. Regelm&auml;ssig fliegt der Hayek-Jet nach Barcelona. Auch
        Fl&uuml;ge nach London, Berlin und Paris sind dokumentiert. Insgesamt
        stiess das Flugzeug letztes Jahr rund 240 Tonnen CO<sub>2</sub> aus.
      </StandardParagraph>
      <StandardParagraph>
        Gern hätte diese Zeitung von Nick Hayek über den Sinn dieser Flüge
        gesprochen – und ob sich die Nutzung auch mit den Nachhaltigkeitszielen
        von Swatch vereinbaren lässt. Trotz mehrmaliger Anfragen liess Hayek die
        Fragen aber unbeantwortet.
      </StandardParagraph>
    </FrontElement>,

    <FrontElement>
      <NameImage>
        <img src={RainerMarcFrey} alt='Rainer-Marc Frey' />
        <h3>Rainer-Marc Frey</h3>
      </NameImage>
      <StandardParagraph>
        Mitten in der Nacht auf den 23. August 2022, um 1.21 Uhr, startete der
        PC-24 von Hedgefond-Pionier und Hobbypilot Rainer-Marc Frey im
        tschechischen Ostrava in Richtung Litauen. Von dort ging es gleich
        weiter nach Lettland, dann nach Estland. In der Morgendämmerung landete
        die Maschine im finnischen Turku. Von da nach Schweden, Dänemark,
        Luxemburg und in etliche weitere europäische Länder, bis Freys PC-24
        schliesslich abends um 23.07 in Budapest landete.
      </StandardParagraph>
      <StandardParagraph>
        14 einzelne Flüge mit 14 Starts und Landungen hat der Jet allein an
        diesem 23. August 2022 hingelegt und dabei über 7000 Liter Kerosin
        verbrannt, was rund 18 Tonnen CO<sub>2</sub> entspricht – mehr als ein
        Durchschnittsschweizer in einem ganzen Jahr verursacht.
      </StandardParagraph>
      <StandardParagraph>
        W&auml;hrend Rainer-Marc Frey diese &laquo;Tour d&rsquo;Europe&raquo;
        absolvierte, berichteten Schweizer Zeitungen an diesem 23. August 2022
        &uuml;ber eine ETH-Studie, wonach die Fl&auml;che der Schweizer
        Gletscher in den letzten 90 Jahren um zwei Drittel geschrumpft ist. Das
        Reformierten-Portal ref.ch publizierte gleichentags einen Artikel
        &uuml;ber Afrika mit dem Titel: &laquo;D&uuml;rre versch&auml;rft
        Hungersnot&raquo; . Und an einem Anlass in Bern unter dem Motto
        &laquo;How to Save the Planet&raquo; warnte der ehemalige
        US-Vizepr&auml;sident Al Gore, in gewissen Weltregionen sei in diesem
        Hitzesommer die &laquo;Grenze der menschlichen
        &Uuml;berlebensf&auml;higkeit ausgelotet worden&raquo;
      </StandardParagraph>
      <StandardParagraph>
        Rainer-Marc Frey ist gemäss «Bilanz»-Reichstenliste zweifacher
        Milliardär und eingefleischter Aviatiker. Laut Bilanz hat er letztes
        Jahr eine besondere SMS an seine Freunde verschickt: «DONE 193/193
        United Nations Countries Visited» – alle Länder der Welt bereist, am
        liebsten im eigenen Jet.
      </StandardParagraph>
      <img src={HBVRF1} alt='PC-24 Jet' />
      <ImageCaption>PC-24 von Rainer-Marc Frey</ImageCaption>
      <StandardParagraph>
        Eine Anfrage zu seinen unzähligen Flügen und der daraus resultierenden
        Umweltbelastung liess Frey trotz mehrmaligen Nachfragens unbeantwortet.
        Aber ein Eintrag auf der Website recordsetters.com verrät wenigstens den
        Hintergrund des 24-Stunden-Parcours vom 23. August 2022: Zusammen mit
        einem Freund stellte Frey einen neuen Weltrekord an besuchten Ländern an
        einem Tag auf. Es waren deren 30. Neben dem Jet kamen auch ein
        Helikopter und Autos zum Einsatz.
      </StandardParagraph>
      <StandardParagraph>
        Zur Klimafrage erkl&auml;rte Rainer-Marc Frey in einem Video auf der
        Rekord-Website, vor seinem PC-24 stehend: &laquo;Wir haben w&auml;hrend
        unserer Vorbereitung oft dar&uuml;ber diskutiert, ob ein solches Projekt
        durchf&uuml;hrbar ist.&raquo; Die L&ouml;sung f&uuml;r ein gutes
        Gewissen: &laquo;Wir kompensieren unseren CO<sub>2</sub>-Fussabdruck mit
        Faktor zwei bei myclimate.&raquo;
      </StandardParagraph>
    </FrontElement>,
    <FrontElement>
      <NameImage>
        <img src={Rolex} alt='Rolex Logo' />
        <h3>Rolex</h3>
      </NameImage>
      <StandardParagraph>
        Der Schweizer Luxusuhrenhersteller Rolex besitzt gleich zwei Firmenjets,
        die häufig unterwegs sind, auch auf kurzen Strecken. So flogen die
        Rolex-Jets letztes Jahr regelmässig die Strecken Genf–Genua,
        Genf–Mailand, Genf–Zürich oder Genf–Paris, obwohl es zwischen diesen
        Städten schnelle Zugverbindungen gibt. Mit einem CO<sub>2</sub>-Ausstoss
        von knapp 4,5 Tonnen pro Flugstunde gehören die beiden Bombardier-Jets
        zu den schmutzigsten.
      </StandardParagraph>
      <img src={HBJFX} alt='HB-JFX Jet' />
      <ImageCaption>Einer der beiden Bombardier-Jets von Rolex</ImageCaption>
      <StandardParagraph>
        Die intensive Nutzung der beiden firmeneigenen Flugzeuge schl&auml;gt
        sich in einem grossen CO<sub>2</sub>-Fussabdruck nieder: &Uuml;ber 3000
        Tonnen CO<sub>2</sub> {' '}
        stiessen die beiden Flieger 2022 aus. Dies steht in starkem Widerspruch
        zum Engagement von Rolex gegen den Klimawandel unter dem Namen
        Perpetual-Planet-Initiative . Seit &uuml;ber 20 Jahren unterst&uuml;tzt
        die Marke Aktivisten, wie etwa den Meeressch&uuml;tzer Titouan Bernicot,
        der sich f&uuml;r den Erhalt der Korallenriffe im S&uuml;dpazifik
        einsetzt. Rolex beschreibt in einem aufwendig produzierten PR-Artikel,
        wie Bernicot erkannte, dass Korallen eine Existenzgrundlage f&uuml;r das
        Meeres&ouml;kosystem darstellen. &laquo;Wird das Wasser jedoch
        beispielsweise zu warm, produzieren sie sch&auml;dliche Chemikalien
        &hellip; in der Folge verlieren die Korallen ihre Farben &hellip; viele
        Korallen &uuml;berleben nicht&raquo;, heisst es auf der Website von
        Rolex. Statt die Erw&auml;rmung der Meere zu bek&auml;mpfen, finanziert
        Rolex das Team um Bernicot, das in einem aufw&auml;ndigen Verfahren
        Korallen pflanzt und kultiviert. &laquo;Rolex unterst&uuml;tzt Bernicot
        in dem Bestreben, eine globale Gemeinschaft von Riffsch&uuml;tzern zu
        mobilisieren und Korallen&ouml;kosysteme auf der ganzen Welt zu
        erhalten&raquo;, schreibt das Unternehmen.
      </StandardParagraph>
      <StandardParagraph>
        Wie geht Rolex mit diesem Widerspruch um? Eine Unternehmenssprecherin
        betont auf Anfrage, man nutze die beiden Privatflieger nur zu
        Geschäftszwecken. «Unsere internationale Präsenz, die Entwicklung und
        das Management unseres Unternehmens erfordern solche Reisen.» Die
        Flieger würden ausschliesslich von Führungskräften des Unternehmens
        genutzt, deren Bedürfnis es sei, «sich schnell, sicher und vertraulich
        überall auf der Welt zu bewegen», sagt Rolex-Sprecherin Virginie
        Chevailler-de Meuron.
      </StandardParagraph>
      <StandardParagraph>
        Auf die kurzen Strecken angesprochen, deutet Rolex einen Kurswechsel an:
        «Diese werden derzeit geprüft, ebenso wie alle anderen Massnahmen, die
        es uns ermöglichen, unseren CO<sub>2</sub>-Fussabdruck zu verringern»,
        sagt Chevailler-de Meuron. Das Unternehmen prüfe die Kompensation der
        Emissionen oder die Verwendung von nachhaltigem Treibstoff.
      </StandardParagraph>
    </FrontElement>,
  ],
}
